<script>
    import Icon from 'svelte-awesome'
    import { spinner } from 'svelte-awesome/icons'
    import { Button } from 'sveltestrap'
    import { createEventDispatcher } from 'svelte'
    export let context
    export let saving
    export let firstPage
    export let lastPage
    export let disableSave
    export let disableNext

    let confirm = false

    const dispatch = createEventDispatcher()
</script>

{#if confirm}
    <div class="row justify-content-end mt-5">
        <div class="col-4 col-sm-6">
            <div class="card">
                <div class="card-body">
                    <p>
                        Upon clicking continue, the onboarding process will be completed and you will be directed to the
                        portal.
                    </p>
                    <p class="text-danger">
                        NOTE: You will no longer be able to access the T.A.B., but will have access to most settings
                        within the portal.
                    </p>
                </div>
            </div>
        </div>
    </div>
{/if}

<div class="d-flex flex-row justify-content-between pb-3 {confirm ? 'mt-3' : 'mt-5'}">
    <div>
        {#if !firstPage}
            <Button
                on:click={() => dispatch('previousStepClicked', { context })}
                color="primary"
                disabled={context.errors || context.changes || confirm}
            >
                Previous Step
            </Button>
        {/if}
    </div>

    <div>
        <p class="text-end">
            {#if saving}
                <span class="text-muted" style="margin-right: 15px;">
                    {#if typeof saving === 'string'}{saving}{/if}
                    <Icon data={spinner} spin />
                </span>
            {/if}
            {#if !lastPage}
                <Button
                    on:click={() => dispatch('save', { context })}
                    color="secondary"
                    disabled={saving || context.errors || !context.changes || disableSave}
                >
                    Save
                </Button>
            {/if}
            {#if confirm}
                <Button on:click={() => (confirm = false)} color="secondary">Cancel</Button>
            {/if}
            <Button
                on:click={() => (lastPage && !confirm ? (confirm = true) : dispatch('nextStepClicked', { context }))}
                color="primary"
                disabled={context.errors || disableNext}
            >
                {#if confirm}Finish{:else if lastPage}Save and Complete!{:else}Save and Continue{/if}
            </Button>
        </p>
    </div>
</div>
